import { render, staticRenderFns } from "./SubtabHubs.vue?vue&type=template&id=24b15c96"
import script from "./SubtabHubs.vue?vue&type=script&lang=js"
export * from "./SubtabHubs.vue?vue&type=script&lang=js"
import style0 from "./SubtabHubs.vue?vue&type=style&index=0&id=24b15c96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports